import React from 'react';
import { ReferentIndex } from '../../../_common/referent';
import { Message } from '../_common/message';

export const Step3 = ({ monReferentRequirements, setMonReferentRequirements }) => {
    return(
        <React.Fragment>
            <ReferentIndex monReferentRequirements={monReferentRequirements} setMonReferentRequirements={setMonReferentRequirements} hasFooter={true} />
            <Message />
        </React.Fragment>
    )
}